export default /*@ngInject*/ function ($scope) {

    //If $scope variable doesnt exist in child it looks in parent

    $scope.addUserGroupToList = addUserGroupToList;
    $scope.deleteSelectedUserGroup = deleteSelectedUserGroup;

    function addUserGroupToList(userGroup) {
        $scope.vm.ListOfAvailableAX2012UserGroups.forEach((row, i) => {
            if (row.Id === userGroup.Id) {
                $scope.vm.ListOfAvailableAX2012UserGroups.splice(i, 1);
                $scope.vm.ListOfSelectedAX2012UserGroups.push(userGroup);
            }
        });
    };


    function deleteSelectedUserGroup(userGroup) {
        $scope.vm.ListOfSelectedAX2012UserGroups.forEach((row, i) => {
            if (row.Id === userGroup.Id) {
                $scope.vm.ListOfSelectedAX2012UserGroups.splice(i, 1);
                $scope.vm.ListOfAvailableAX2012UserGroups.push(row);
            }
        });
    };

}